import gql from 'graphql-tag';

const ourClientsQuery = gql`
  query GetOurClients {
    ourClients {
      displayText
      subtitle {
        html
      }
      clientCollection {
        contentItems {
          ... on Client {
            displayText
            clientLogo {
              urls
            }
            clientURL {
              url
              text
            }
          }
        }
      }
    }
  }
`;

export {
  ourClientsQuery,
};